import memoizeOne from "memoize-one";

const FORCE_STAGING = false;

const getAPIBaseURL = (windowHostname) => {
    let baseURL = "https://api.aivr-dev.video";
    if (windowHostname === "view.aivr.video") {
        baseURL = "https://api.aivr.video";
    } else if (windowHostname === "view-dev.aivr.video") {
        baseURL = "https://api-dev.aivr.video";
    } else if (windowHostname === "view-test.aivr.video" || windowHostname === "test.localhost") {
        baseURL = "https://api-test.aivr.video";
    } else if (windowHostname === "view-widget.aivr.video" || windowHostname === "widget.localhost") {
        baseURL = "https://api-widget.aivr.video";
    } else if (windowHostname === "view-widgetdev.aivr.video" || windowHostname === "widgetdev.localhost") {
        baseURL = "https://api-widgetdev.aivr.video";
    } else if (windowHostname === "view.aivr-au.video") {
        baseURL = "https://api.aivr-au.video";
    } else if (windowHostname === "view-dev.aivr-au.video") {
        baseURL = "https://api-dev.aivr-au.video";
    }

    //To be removed at a later date
    else if (windowHostname === "localhost") {
        baseURL = "https://api-dev.aivr.video";
    }
    return baseURL;
};

const getBaseUrl = (windowHostname) => {
    const domain = windowHostname.split(".").slice(-2).join(".");
    let baseURL = ".aivr.video";
    if (domain === "aivr-dev.video") {
        baseURL = ".aivr-dev.video";
    } else if (domain === "aivr-au.video") {
        baseURL = ".aivr-au.video";
    } else if (domain === "localhost") {
        baseURL = ".aivr-dev.video";
        if (FORCE_STAGING) {
            baseURL = ".aivr.video";
        }
    }
    // else if (domain === "localhost") {
    //     baseURL = ".aivr-dev.video";
    // }
    return baseURL;
};

const getImagePackUrl = (windowHostname) => {
    let imagePackURL = "https://imagepack.aivr.video";
    if (windowHostname === "view.aivr-dev.video") {
        imagePackURL = "https://imagepack.aivr-dev.video";
    } else if (windowHostname === "localhost") {
        imagePackURL = "https://imagepack.aivr-dev.video";
    } else if (windowHostname === "view.aivr-au.video") {
        imagePackURL = "https://imagepack.aivr-au.video";
    } else if (windowHostname === "view-dev.aivr-au.video") {
        imagePackURL = "https://imagepack.aivr-au.video";
    }
    // else if (windowHostname === "localhost") {
    //     imagePackURL = "https://imagepack.aivr-dev.video";
    // }

    return imagePackURL;
};

const memoizedGetBaseUrl = memoizeOne(getBaseUrl);
const memoizedAPIBaseURL = memoizeOne(getAPIBaseURL);
const memoizedImagePackURL = memoizeOne(getImagePackUrl);

export const MEMOIZED_DOMAIN_URL = memoizedGetBaseUrl(window.location.hostname);
export const MEMOIZED_API_BASE_URL = memoizedAPIBaseURL(window.location.hostname);
export const MEMOIZED_IMAGEPACK_URL = memoizedImagePackURL(window.location.hostname);
